import React, { useEffect, useState } from "react";
import isEqual from "react-fast-compare";
import { useSelector } from "react-redux";
import GoogleTrend from "../DeepDivetab/GoogleTrend/GoogleTrend";
const GoogleTrendsContainerForGTrend = ({}) => {
  const [params, setParams] = useState(null);
  const [iframes, setIframes] = useState([]);
  const deepdive_object = useSelector(
    (state) => state?.WidgetMaker?.deepdive_object
  );
  const countryStateCityFilters = useSelector(
    (state) => state?.Screens?.screen?.country_state_city_filters
  );
  useEffect(() => {
    // for creating params and access deepdive object
    if (deepdive_object) {
      let selectedKeyword = deepdive_object?.deepdive_on?.x_axis?.value?.trim();
      let selectedRegion;
      if (countryStateCityFilters && Array.isArray(countryStateCityFilters)) {
        let selectedCountry = countryStateCityFilters?.find(
          (f) => f?.attribute === "twitter_trend_country"
        );
        selectedRegion =
          selectedCountry?.columns && Array.isArray(selectedCountry?.columns)
            ? selectedCountry?.columns?.[0]?.country_code
            : selectedCountry?.country_code
            ? selectedCountry?.country_code
            : null;
      }
      let params = {
        startDate: deepdive_object?.start_date,
        endDate: deepdive_object?.end_date,
        timeOffset: new Date()?.getTimezoneOffset(),
        keyword: selectedKeyword,
        region: selectedRegion,
      };
      setParams(params);
    }
  }, [deepdive_object]);
  return (
    <>
      <div id="GoogleTrendsContainerForGTrend" className="m-0">
        {params ? (
          <>
            <div className="row m-0 mb-sm-3">
              <div className={"col-lg-12 p-0"}>
                <GoogleTrend
                  widget_id="twitter_trend_1"
                  type="GEO_MAP"
                  keyword={params?.keyword}
                  region=""
                  params={params}
                  className={""}
                />
              </div>
            </div>
            <div className="row m-0 mb-sm-3">
              <div className={"col-lg-6 p-0 pr-3"}>
                <GoogleTrend
                  widget_id="twitter_trend_2"
                  type="RELATED_TOPICS"
                  keyword={params?.keyword}
                  region=""
                  params={params}
                  className={""}
                />
              </div>
              <div className={"col-lg-6 p-0"}>
                <GoogleTrend
                  widget_id="twitter_trend_2"
                  type="RELATED_QUERIES"
                  keyword={params?.keyword}
                  region=""
                  params={params}
                  className={""}
                />
              </div>
              {/* <div className="col-lg-4 p-2">
                <div className="google-list TrendWidget border-0 border-radius-4">
                  <div className="heading">
                    <span>Similar searches - {params?.keyword}</span>
                    <div
                      className="embed-subtitle"
                      style={{ height: "1.7rem" }}
                    ></div>
                  </div>
                  <ul id="GoogleRelatedQuries"></ul>
                </div>
              </div> */}
            </div>
          </>
        ) : (
          <>
            <div className="loader mx-auto" style={{ height: "calc(60rem)" }}>
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default React.memo(GoogleTrendsContainerForGTrend, isEqual);
